module.exports = __webpack_public_path__ + "img/logo.b0d1a532.png";